<app-loader></app-loader>
<!-- <div *ngIf="isOpen" class=" fixed inset-0 bg-black/50 flex items-center justify-center z-50 opacity-90"> -->
<div
  *ngIf="isOpen"
  class="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
>
  <div class="bg-[#2A2A2A] rounded-3xl w-[400px] p-8 text-center">
    <div class="flex justify-center mb-6">
      <img
        [src]="profileImage"
        alt="Profile"
        class="w-24 h-24 rounded-full object-cover"
      />
    </div>
    <h2 class="text-white text-xl mb-8">
      Are you sure you want to delete your Casinoze account?
    </h2>
    <div class="mb-6 relative">
      <input
        [type]="showPassword ? 'text' : 'password'"
        [value]="password"
        (input)="updatePassword($event)"
        placeholder="Enter password to confirm"
        class="w-full p-2 bg-white bg-opacity-10 rounded text-white"
      />
      <fa-icon
        class="absolute right-4 top-[50%] transform -translate-y-1/2 cursor-pointer text-white"
        (click)="togglePassword()"
        [icon]="showPassword ? hideicon : showicon"
      ></fa-icon>
    </div>
    <div class="flex gap-4 justify-center">
      <button
        (click)="onCancel.emit()"
        class="px-8 py-2 rounded-lg border border-gray-600 text-white hover:bg-gray-700/50 transition-colors"
      >
        Cancel
      </button>
      <button
        (click)="onConfirm.emit(password)"
        [disabled]="!isPasswordFilled"
        style="background: var(--gradient)"
        class="px-8 py-2 rounded-lg text-white hover:bg-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Delete
      </button>
    </div>
  </div>
</div>
